import { CharCount } from './character-count';

document.addEventListener('DOMContentLoaded', () => {
    const charCountElements = document.querySelectorAll('.character-count');

    charCountElements.forEach((element) => {
        new CharCount(element);
    });
});
